import { defineMessage } from 'services/localization';

export const messages = {
    beforeTable: defineMessage('the_request_cant_be_pai_ng_the_approval_process'),
    afterTable: defineMessage('to_send_payments_with_t_st_and_submit_a_new_one'),
    beneficiary: defineMessage('beneficiary'),
    discrepancy: defineMessage('fields_edited_in_airwallex'),
    ok: defineMessage('ok_1'),
    isRemoved: defineMessage('the_beneficiary_has_been_removed_from_airwallex'),
    accountName: defineMessage('account_name'),
    bankCountryCode: defineMessage('bank_location'),
    bankName: defineMessage('bank_name_1'),
    iban: defineMessage('iban'),
    swiftCode: defineMessage('swift_code_2'),
    accountNumber: defineMessage('account_number'),
    bankBranch: defineMessage('bank_branch_1'),
    localClearingSystem: defineMessage('payment_method'),
    accountingRoutingType1: defineMessage('routing_code_type'),
    accountingRoutingType2: defineMessage('routing_code_type'),
    accountingRoutingValue1: defineMessage('sort_code'),
    accountingRoutingValue2: defineMessage('routing_code_value'),
};
